<template>
    <div >
        <div class="items-list"><router-view/></div>
        <div class="items" :style="{'width': withItems +'px'}">
            <div class="item" :class="{'active': item ==='Documentos'}" @click="$router.push('/solicitudes/documentos')">
                Documentos
            </div>
            <div class="item" :class="{'active': item === 'ProductosDelete'}" @click="$router.push('/solicitudes/productos')">
                Eliminar productos
            </div>
            <div class="item" :class="{'active': item === 'Picture'}" @click="$router.push('/solicitudes/picture')">
                Cambiar imagen
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'items',
    data() {
        return {
            withItems: window.innerWidth - 350,
            item: null
        }
    },
    mounted() {
        this.item = this.$route.name
        if (!this.$store.state.constants.COLLAPSE) {
            this.withItems = window.innerWidth - 80
        } else {
            this.withItems = window.innerWidth - 350
        }
        this.$root.$on('collapse', (block) => {
            if (block) {
                this.withItems = window.innerWidth - 350
            } else {
                this.withItems = window.innerWidth - 80
            }
        })
        this.$root.$on('solicitud', (block) => {
            this.item = block
        })
    }
}
</script>

<style scoped>
    .items {
        position: fixed;
        text-align: center;
        display: flex;
        transition: width 1s;
    }
    .item {
        background-color: #e0b059;
        width: 50%;
        padding: 20px;
        color: #fff;
        font-weight: bolder;
        border-style: outset;
        min-height: 12vh;
    }
    .active{
        border-style: inset;
        background-color: #fff;
        color: #e0b059;
    }
    .item:hover {
        border-style: double;
        border-color: black;
    }
    .items-list {
       width: 100%;
       min-height: 78vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Solicitudes/Items.vue